import React, {useEffect, useState, useRef} from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useMessage } from '../../context/message'
import { useAuth } from '../../context/auth'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import Container from '@material-ui/core/Container'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'
import InfoIcon from '@material-ui/icons/Info'
import Grid from '@material-ui/core/Grid'
import Pagination from '@material-ui/lab/Pagination'
import MenuItem from '@material-ui/core/MenuItem'
import InfoDialog from '../display/InfoDialog'
import AdjustRoundedIcon from '@material-ui/icons/AdjustRounded'

const useStyles = makeStyles((theme) => ({
  allChat_container: {
    'borderLeft': '2px solid',
    display: 'inline-block',
    width: '20%',
    height: '750px'
  },
  allChat_list: {
    height: '95%',
  },
  chat_container: {
    display: 'inline-block',
    width: '80%',
    height: '100%',
  },
  chat_messages: {
    height: '95%',
    maxHeight: '665px',
    overflow: 'auto',
    overflowAnchor: 'None',
    'borderBottom': '2px solid',
  },
  page_container: {
    minHeight: '500px',
    minWidth: '1350px'
  },
  received: {
    'width': '85%',
    'border-style': 'solid',
    'border-color': theme.palette.primary.main,
    'border-radius': 40,
    'margin': theme.spacing(2)
  },
  sent: {
    'background-color': theme.palette.primary.main,
    'maxWidth': '85%',
    'minHeight': 40,
    'float': 'right',
    'border-style': 'solid',
    'borderColor': theme.palette.primary.main,
    'border-radius': 40,
    'paddingLeft': 10,
    'paddingRight': 10,
    'paddingTop': 10,
    'paddingBottom': 10,
    'overflow-x':'hidden',
    'overflowAnchor': 'auto',
  },
  divider: {
    'border': '2px solid',
  },
  title_bar: {
    padding: theme.spacing(1),
    borderBottom: '2px solid',
  },
}));

export default function AdminChatroom({id}){
  const classes = useStyles()
  const {setMessage} = useMessage()
  const { auth } = useAuth()
  const [messages, setMessages] = useState([])
  const [focus, setFocus] = useState(false)
  const [conversations, setConversations] = useState([])
  const [conversation_id, setConversation_id] = useState(id)
  const [conversation_title, setConversation_title] = useState('Select a conversation')
  const messagesEndRef = useRef(null)
  const[info, setInfo] = useState(false)
  const [leave,setLeave] = useState(false)
  const [closed, setClosed] = useState(false)
  const [type, setType] = useState('')
  const [infoId, setInfoId] = useState(0)
  const [senderId, setSenderId] = useState(0)
  const [receiverId, setReceiverId] = useState(0)
  //Pagination
  const [page, setPage] = useState(1)
  const [pageCount, setPageCount] = useState(1)

  const scrollToBottom = () => {
    messagesEndRef.current.scrollIntoView()
  }

  useEffect(() => {
    scrollToBottom()
  }, [focus])

  const handlePageChange = (event, value) => {
    setPage(value)
  }

  const open = (conversation) => () => {
    if(conversation.conversation_id !== conversation_id){
      setInfoParams(conversation)
      setConversation_id(conversation.conversation_id)
    }
  }

  const setInfoParams = (conversation) => {
    console.log(conversation)
    if(conversation.bid_id){
      setType('listing')
      setInfoId(conversation.bid_id)
    } else if (conversation.inquiry_bids_id) {
      setType('inquiry')
      setInfoId(conversation.inquiry_bids_id)
    } else if (conversation.listing_id && !conversation.bid_id) {
      setType('listing_info')
      setInfoId(conversation.listing_id)
    } else if (conversation.inquiry_id && !conversation.inquiry_bids_id) {
      setType('inquiry_info')
      setInfoId(conversation.inquiry_id)
    }
  }

  const openInfo = (event) => {
    setInfo(true)
  }

  const closeInfo = () => {
    setInfo(false)
  }

  useEffect(() => {
      fetch('/api/message/all', {
        method: 'GET',
        headers: {
          'x-access-token': sessionStorage.getItem('token')
        }
      })
      .then((response) => auth(response))
      .then((response) => {
        setConversations(response.data)
        console.log('data: ', response.data)
        if(response.data)
          setPageCount(Math.ceil(response.data.length/10))
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [] )

  useEffect(()=> {
    if(conversation_id && conversation_id != 0) {
      fetch(`/api/message/conversation/admin/${conversation_id}`,{
          method: 'GET',
          headers: {
            'x-access-token': sessionStorage.getItem('token')
          }
      })
      .then((response) => auth(response))
      .then((response) => {
        if(response.message){
          setMessage(response.message)
        }
        else {
          setMessages(response.data)
          setClosed(response.closed)
          setInfoParams(response.conversation)
          setConversation_title(response.conversation.conversation_title)
          setFocus(!focus)
          setSenderId(response.conversation.trader_id)
          setReceiverId(response.conversation.terminal_id)
        }

      })
      .catch((error) => {
        setMessage({'type': 'error', 'text': 'Error! Conversation does not exist.'})
        console.error('Error: ', error)
      })
    }
  }, [conversation_id,])

  return(
    <Paper>
      <div className = {classes.page_container}>
        <InfoDialog
          open = {info}
          onClose = {closeInfo}
          type = {type}
          id = {infoId}
        />
        <div className = {classes.title_bar}>
          <Typography>
            {conversation_title}
          </Typography>
          {conversation_title !== 'Select a conversation' &&
            <IconButton color = 'primary' onClick = {(e) => openInfo(e)}>
              <InfoIcon/>
            </IconButton>
          }
        </div>
        <div className = {classes.chat_container}>
          <Grid>
            <Grid item >
              <Container className = {classes.chat_messages}>
                <List>
                  {messages && messages.map((message, key) => (
                    <ListItem key = {key}>
                      <Grid item xs = {12}>
                        <Tooltip title= {(message['author'] ? receiverId: senderId)}>
                          <Typography className = {classes.sent} style = {!message['author'] ? {float:'left', 'backgroundColor': '#424242'} : null}>
                            {message['message']}
                          </Typography>
                        </Tooltip>
                      </Grid>
                    </ListItem>
                  ))}
                  {closed &&
                    <ListItem key = 'closed'>
                      <Grid item xs = {12}>
                        <Typography className = {classes.sent} style = {{'backgroundColor': 'red', 'borderColor': 'red'}}>
                          {'Chat has been closed!'}
                        </Typography>
                      </Grid>
                    </ListItem>
                  }
                  <div ref={messagesEndRef} />
                </List>
              </Container>
            </Grid>
          </Grid>
        </div>
        <div className = {classes.allChat_container}>
            <List className = {classes.allChat_list}>
              {conversations && conversations.slice((page-1)*10,(page*10)).map((c) => (
                <ListItem button onClick = {open(c)} key = {c.conversation_id}>
                  <ListItemText
                    primary = {
                      <Typography variant = 'body2' style = {c.closed ? {'color': '#d3d3d3'} : null}>
                          {`${c.conversation_id}. ${c.conversation_title}`}
                      </Typography>
                    }
                    secondary = {c.closed ? 'Chat has been closed!' : c.lastMessage}
                    className = {c.last_read !== 0 ? classes.unread : null}
                  />
                  {(c.last_read !== 0 && c.conversation_id !== conversation_id) &&
                    <AdjustRoundedIcon color = 'primary'/>
                  }
                </ListItem>
              ))}
            </List>
            <Pagination count={pageCount} size = 'small' page={page} onChange={handlePageChange}/>
        </div>
      </div>
    </Paper>
  )
}
